import { useNavigate } from "react-router";
import DashboardCard from '../common/DashboardCard';
import { Box, Typography, Button, Stack } from '@mui/material';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import ViewListIcon from '@mui/icons-material/ViewList';

function Bookings(props: any) {
    const dashboardInfo = props.dashboardInfo;
    const navigate = useNavigate();

    return (
        <DashboardCard
            title="Recent Bookings"
            icon={<BookOnlineIcon />}
            actions={
                <Button
                    startIcon={<ViewListIcon />}
                    onClick={() => navigate("/share/business/charging-transactions")}
                >
                    View All Bookings
                </Button>
            }
        >
            <Stack spacing={2}>
                {dashboardInfo.recentBookings?.map((booking: any, index: number) => (
                    <Box 
                        key={index}
                        sx={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            p: 1,
                            '&:not(:last-child)': {
                                borderBottom: '1px solid',
                                borderColor: 'divider'
                            }
                        }}
                    >
                        <Box>
                            <Typography variant="body2" color="text.secondary">
                                {booking.businessName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {booking.chargePointName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {booking.startTime} - {booking.endTime}
                            </Typography>
                        </Box>
                        <Typography variant="body1" color="primary">
                            {booking.status}
                        </Typography>
                    </Box>
                ))}
            </Stack>
        </DashboardCard>
    );
}

export default Bookings;
